
import React from 'react';
import Navbar from '../Navbar';

interface NavbarContainerProps {
  onMenuClick: () => void;
  isMobile: boolean;
  onToggleSidebar: () => void;
}

export const NavbarContainer = ({
  onMenuClick,
  isMobile,
  onToggleSidebar,
}: NavbarContainerProps) => {
  return (
    <Navbar 
      onMenuClick={onMenuClick} 
      isMobile={isMobile} 
      onToggleSidebar={onToggleSidebar}
    />
  );
};
